// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CreateOverrideResponse
 */
export interface CreateOverrideResponse {
  /**
   * ID of the newly created override.
   * @type {string}
   * @memberof CreateOverrideResponse
   */
  overrideID?: string;
}

/**
 * Check if a given object implements the CreateOverrideResponse interface.
 */
export function instanceOfCreateOverrideResponse(
  value: object,
): value is CreateOverrideResponse {
  return true;
}

export function CreateOverrideResponseFromJSON(
  json: any,
): CreateOverrideResponse {
  return CreateOverrideResponseFromJSONTyped(json, false);
}

export function CreateOverrideResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateOverrideResponse {
  if (json == null) {
    return json;
  }
  return {
    overrideID: json['overrideID'] == null ? undefined : json['overrideID'],
  };
}

export function CreateOverrideResponseToJSON(
  json: any,
): CreateOverrideResponse {
  return CreateOverrideResponseToJSONTyped(json, false);
}

export function CreateOverrideResponseToJSONTyped(
  value?: CreateOverrideResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    overrideID: value['overrideID'],
  };
}
